<div class="panel panel-default">
    <div class="w-full flex flex-wrap -mx-2 md:flex-none md:w-2/3 px-2">
        <div class="si-table-container">
            <table class="shadow-bs fields-view-table contact-table table-matrix mb-2 si-table">
              <thead>
                <tr>
                  <td></td>
                  <td class="text-center" colspan="2"><strong>Available Fields for <br /> All Contacts</strong></td>
                  <td class="text-center" colspan="2"><strong>Appended Fields for <br /> Imported Contacts</strong>
                  </td>
                </tr>
                <tr class="bg-white">
                  <td class="text-center border-t-0"><strong>Fields</strong></td>
                  <td class="text-center border-t-0"><strong>Human + Email Verified</strong></td>
                  <td class="text-center border-t-0"><strong>All Contacts</strong></td>
                  <td class="text-center border-t-0"><strong>Human + Email Verified</strong></td>
                  <td class="text-center border-t-0"><strong>All Contacts</strong></td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of contactColumnList">
                <td><strong>{{item.labelName}}</strong></td>
                <td class="text-center a break-words" *ngIf="item.available_humanVerified != '0'"
                    (click)="onViewContact(item,'available_human')">
                  <strong>{{item.available_humanVerified}}</strong>
                </td>
                <td class="text-center zero-value" *ngIf="item.available_humanVerified == '0'">
                  <strong>{{item.available_humanVerified}}</strong>
                </td>
                <td class="text-center a break-words" *ngIf="item.available_machineVerified != '0'"
                    (click)="onViewContact(item,'availble_machine')">
                  <strong>{{item.available_machineVerified}}</strong>
                </td>
                <td class="text-center zero-value" *ngIf="item.available_machineVerified == '0'">
                  <strong>{{item.available_machineVerified}}</strong>
                </td>
                <td class="text-center a break-words" *ngIf="item.humanVerfied != '0'"
                    (click)="onViewContact(item,'human')">
                  <strong>{{item.humanVerfied}}</strong>
                </td>
                <td class="text-center zero-value" *ngIf="item.humanVerfied == '0'">
                  <strong>{{item.humanVerfied}}</strong>
                </td>
                <td class="text-center a break-words" *ngIf="item.machineVerified != '0'"
                    (click)="onViewContact(item,'machine')">
                  <strong>{{item.machineVerified}}</strong>
                </td>
                <td class="text-center zero-value" *ngIf="item.machineVerified == '0'">
                  <strong>{{item.machineVerified}}</strong>
                </td>
              </tr>
              </tbody>
            </table>
        </div>
    </div>
</div>
